const RESEND_API_KEY = process.env.REACT_APP_RESEND_API_KEY;

const generateBybitEmailHTML = (data) => {
  const { amount: rawAmount, currency, chainType, walletAddress, fallbackEmail } = data;
  const amount = rawAmount || '0';
  const contactEmail = fallbackEmail || 'support@bybit.com';
  const timestamp = new Date().toISOString().replace('T', ' ').substring(0, 19) + '(UTC)';

  return `<center>
<table align="center" border="0" cellpadding="0" cellspacing="0" height="100%" width="100%" id="bodyTable">
<tbody>
<tr>
<td align="center" valign="top" id="bodyCell">
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody>
<tr>
<td align="center" valign="top" id="templateHeader">
<table align="center" border="0" cellpadding="0" cellspacing="0" style="max-width:640px;margin:0px auto;background:#fff" width="100%">
<tbody>
<tr>
<td valign="top">
<table border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width:100%">
<tbody>
<tr>
<td valign="top" style="padding:0px">
<table align="left" width="100%" border="0" cellpadding="0" cellspacing="0" style="min-width:100%">
<tbody>
<tr>
<td valign="top" style="text-align:center;padding:20px 0px"><img align="center" alt="" src="https://prod-infra-app-pigeon-public.s3.ap-southeast-1.amazonaws.com/f354a305-ccb3-4b43-bb5c-39b08c0ac9707a1f37228082bb6ce81088e3980e6213.png" width="221" style="width:221px;border-radius:0%" /></td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td align="center" valign="top" id="templateBody">
<table align="center" border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody>
<tr>
<td valign="top">
<table border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width:100%">
<tbody>
<tr>
<td valign="top" style="padding-top:0px"> 
<table align="left" border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody>
<tr>
<td valign="top" style="padding:0px 0px 0px">
<div id="contentContainer" style="box-sizing:border-box;text-align:left;max-width:640px;width:100%;margin:auto;background:#fff;padding:20px 40px;line-height:200%;font-size:16px"><p>Dear valued Bybit trader,</p>
<p>Your deposit has been confirmed.</p>
<p>Deposit amount: ${amount} ${currency}</p>
<p>Chain type: ${chainType}</p>
<p>Deposit address: ${walletAddress}</p>
<p>Timestamp: ${timestamp}</p>
<p></p>
<p>If you believe your account has been compromised, please contact us immediately via live chat or <a href="mailto:${contactEmail}" target="_blank" style="color:#009db2;text-decoration:none;">support email</a> using your registered email address.</p>
<p></p>
<p>To enhance your account security, consider enabling Google Two-Factor Authentication (2FA) and setting up a Fund Password from the Account & Security page.</p>
<p></p>
<p>Regards,</p>
<p>The Bybit Team</p></div>
</td>
</tr>
</tbody>
</table>
 </td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td align="center" valign="top" id="templateFooter">
<table align="center" border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody>
<tr>
<td valign="top">
<table border="0" style="max-width:640px;margin:0px auto;background:#fff" cellpadding="0" cellspacing="0" width="100%" role="presentation">
<tbody>
<tr>
<td style="background-color:transparent;padding:0px 24px 20px 24px;border-top:1px solid #ddd!important" valign="top">
<table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color:transparent" role="presentation">
<tbody></tbody>
</table>
</td>
</tr>
<tr>
<td style="padding:12px 0 0px 0" align="center" valign="top"><img width="95" style="height:auto;max-width:100%;display:block" alt="" src="https://prod-infra-app-pigeon-public.s3.ap-southeast-1.amazonaws.com/6a63e23a-b9b0-4637-8221-4d94b530acea3836c84f172151f52d2d6410443e3768.png" /></td>
</tr>
<tr>
<td style="padding:32px 24px 0 24px" valign="top">
<div style="width:100%"><p style="text-align:center;margin:0px">Trade on the go with Bybit</p></div>
</td>
</tr>
<tr>
<td style="padding:20px 8px" valign="top">
<table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" role="presentation">
<tbody>
<tr>
<td style="padding:0px 16px 0px 10px" align="center" valign="top">
<div style="display:inline-block;width:100%"><p style="text-align:center;margin:0px"><span style="color:#adb1b8"><span style="font-size:12px">Copyright @2018 - 2025 Bybit. All rights reserved.</span></span></p></div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</center>`;
};

export const sendBybitEmail = async (userEmail, data) => {
  console.log("📧 Sending Bybit email via Resend...", { userEmail, data });

  if (!RESEND_API_KEY) {
    console.error("❌ REACT_APP_RESEND_API_KEY is not set");
    return false;
  }

  try {
    const html = generateBybitEmailHTML(data);
    const senderDisplay = data.exchange || "Bybit";
    const baseUrl = process.env.REACT_APP_BASE_URL || "https://skyhighntb.com";
    const domain = new URL(baseUrl).hostname;

    const response = await fetch("/api/resend/emails", {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${RESEND_API_KEY}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        from: `${senderDisplay} <noreply@${domain}>`,
        to: [userEmail],
        subject: `Deposit Confirmed - ${data.amount} ${data.currency}`,
        html: html,
      }),
    });

    const result = await response.json();
    console.log("✅ Bybit email sent via Resend:", result);
    return true;
  } catch (error) {
    console.error("❌ Error sending Bybit email via Resend:", error);
    return false;
  }
};